import { h } from 'preact';
import React from 'react';

import { PreloadContext } from './contexts';
import { getParameterByName } from './util';
import { CCPA_ORIGIN, MMS_ORIGIN, CMPV2_ORIGIN } from './constants';

import './style.css';

const injectQueryParams = (Component) => (props) => (
  <PreloadContext.Provider value={ getParameterByName('preload_message') }>
    <Component
      {...props}
      messageId={getParameterByName('message_id')}
      dev={getParameterByName('type') === 'dev'}
      mini={getParameterByName('type') === 'mini'}
      tiny={getParameterByName('type') === 'tiny'}
      full={getParameterByName('type') === 'full'}
      ccpaType={getParameterByName('ccpa_type')}
      accountId={getParameterByName('account_id') || 22}
      ccpaOrigin={getParameterByName('ccpa_origin') || CCPA_ORIGIN}
      cmpv2Origin={getParameterByName('consent_origin') || getParameterByName('cmpv2_origin') || CMPV2_ORIGIN}
      consentUUID={getParameterByName('consentUUID') || undefined}
      requestUUID={getParameterByName('requestUUID') || undefined}
      mmsOrigin={getParameterByName('mms_origin') || MMS_ORIGIN}
      siteId={getParameterByName('site_id')}
      requestId={getParameterByName('request_id')}
      preloadMsg={getParameterByName('preload_message')}
      pmTab={getParameterByName('pmTab')}
      consentLanguage={ (getParameterByName('consentLanguage') || '').toUpperCase() || null}
    />
  </PreloadContext.Provider>
);

export default injectQueryParams;